import { namedColor } from "util/color";

export const NEUTRAL_LIGHT_COLOR = namedColor("hare");
export const NEUTRAL_DARK_COLOR = namedColor("eel");
export const DARK_RED_COLOR = namedColor("fire-ant");
export const LIGHT_RED_COLOR = namedColor("cardinal");

const SEGMENT_COLORS = [
  namedColor("macaw"),
  namedColor("fox"),
  namedColor("beetle"),
  namedColor("owl"),
  namedColor("starfish"),
  namedColor("grizzly"),
  namedColor("bee"),
  namedColor("narwhal"),
];

const versionColors = new Map<string, Map<string, string>>();

const getSegmentColor = (index: number) =>
  SEGMENT_COLORS[index % SEGMENT_COLORS.length];

export const getVersionColor = (platform: string, version: string) => {
  const platformMap = versionColors.get(platform) ?? new Map();
  versionColors.set(platform, platformMap);
  const color = platformMap.get(version) ?? getSegmentColor(platformMap.size);
  platformMap.set(version, color);
  return color;
};
